export enum FilterUsersDirectCare {
    NoMatter = 'noMatterDC',
    OnlyDC = 'onlyDC',
    HideDC = 'hideDC',
}
